import { FormInput } from '../../..';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import { Row } from 'reactstrap';
import SettingsFormProps from '../SettingsFormProps';
import { TemperatureModeCutback } from '../icons';
import { observer } from 'mobx-react';

const TemperatureCutbackField = ({ translate, settingsModel, accessTable, disabled }: SettingsFormProps) => {
  const label = translate(x => x.forms.airdome.settings.temperatureCutback);

  return <Row>
    <div className="settings-field-icon">
      <TemperatureModeCutback style={{ width: '100%', height: 40 }} />
    </div>
    <div className="settings-field-input">
      <FormInput {...{
        model: new FormInputModel({
          label,
          validationSchema: settingsModel.temperatureCutbackValidationSchema.label(label),
          placeholder: label,
          handleValueModel: new HandleValueModel({
            setValue: settingsModel.temperatureCutback.setValue,
            inputType: 'number'
          }),
          inputId: 'TemperatureCutback',
          value: settingsModel.temperatureCutback.Value ? (Math.round(settingsModel.temperatureCutback.Value * 10) / 10).toString() : '',
          readonly: disabled || !accessTable.edit
        })
      }} />
    </div>
  </Row>;
};

export default observer(TemperatureCutbackField);
